/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-16 15:44:29
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/Subscription.ts
 */
import { ActionType } from 'src/types/common/common';

import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   Poster,
  //   ProductGridDisplay,
  Subscription,
  //   ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const SubscriptionFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnSubscriptionItemAdd = (id, posterType, category) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: posterType, category });
    }
  };

  const handleOnSubscriptionItemDelete = (id, index, category) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.delete,
        id,
        data: { index },
        category,
      });
    }
  };

  const handleOnSubscriptionItemChange = (
    id,
    index,
    modifiedData,
    category,
  ) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
        category,
      });
    }
  };

  const handleOnSubscriptionItemSort = (id, from, to, category) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
        category,
      });
    }
  };

  const handleOnSubscriptionStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnSubscriptionModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };
  const handleOnSubscriptionItemDeleteAll = (id, category) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.deleteAll,
        id,
        data: [],
        category,
      });
    }
  };
  const handleOnSubscriptionItemReselect = (id, products, category) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reselect,
        id,
        data: products,
        category,
      });
    }
  };
  return {
    handleOnSubscriptionItemAdd,
    handleOnSubscriptionItemDelete,
    handleOnSubscriptionItemChange,
    handleOnSubscriptionItemSort,
    handleOnSubscriptionStaticChange,
    handleOnSubscriptionModuleTypeChange,
    handleOnSubscriptionItemDeleteAll,
    handleOnSubscriptionItemReselect,
  };
};
const generateSubscription = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  allDisabled,
}) => {
  const {
    handleOnSubscriptionItemAdd,
    handleOnSubscriptionItemDelete,
    handleOnSubscriptionItemChange,
    handleOnSubscriptionItemSort,
    handleOnSubscriptionStaticChange,
    handleOnSubscriptionItemDeleteAll,
    handleOnSubscriptionItemReselect,
    // handleOnSubscriptionModuleTypeChange,
  } = SubscriptionFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: Subscription,
    props: {
      onItemAdd: handleOnSubscriptionItemAdd, //
      onItemChange: handleOnSubscriptionItemChange, //
      onItemSort: handleOnSubscriptionItemSort, //
      onItemDelete: handleOnSubscriptionItemDelete, //
      onStaticChange: handleOnSubscriptionStaticChange, //
      onItemDeleteAll: handleOnSubscriptionItemDeleteAll,
      onItemReselect: handleOnSubscriptionItemReselect,
      allDisabled,
      //onModuleTypeChange: handleOnSubscriptionModuleTypeChange,
    },
  };
};
export { generateSubscription };
